import { Mesh, MeshBasicMaterial, type Scene, SphereGeometry } from 'three';
import type { CombatWorld } from './CombatWorld';

/**
 * Render-side mirror of CombatWorld's in-flight projectiles (spec 0026):
 * a small pool of emissive-looking spheres synced each frame. The sim owns
 * the projectile truth; this class never touches it.
 */
export class ProjectileVisuals {
  private readonly pool: Mesh[] = [];
  private readonly geometry = new SphereGeometry(1, 10, 8);

  constructor(
    private readonly scene: Scene,
    private readonly combat: CombatWorld,
  ) {}

  update(): void {
    const views = this.combat.projectileViews;
    while (this.pool.length < views.length) {
      const mesh = new Mesh(
        this.geometry,
        new MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.95 }),
      );
      mesh.frustumCulled = false;
      this.scene.add(mesh);
      this.pool.push(mesh);
    }
    for (let i = 0; i < this.pool.length; i++) {
      const mesh = this.pool[i];
      const view = views[i];
      if (!mesh) continue;
      if (!view) {
        mesh.visible = false;
        continue;
      }
      mesh.visible = true;
      mesh.position.copy(view.position);
      mesh.scale.setScalar(view.radius * 0.6); // visual slightly inside the hit radius
      (mesh.material as MeshBasicMaterial).color.setHex(view.color);
    }
  }

  /** Re-adds pooled meshes after a scene.clear() (map switch). */
  reattach(): void {
    for (const mesh of this.pool) {
      mesh.visible = false;
      this.scene.add(mesh);
    }
  }
}
